import { type ReactNode } from 'react';

import { Box, Hidden, Text, theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import { AnimatedBenefits } from './AnimatedBenefits';

const ImageWrapper = styled(Box)`
  height: 218px;
  ${mediaMinWidth('sm')} {
    height: 730px;
  }
  ${mediaMinWidth('md')} {
    height: 100%;
  }
`;

const PromoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['4x']};
  padding: ${theme.spacing['6x']} 0;
  max-width: 90%;
  margin: 0 auto;

  &.has-benefits {
    gap: 0;
  }

  ${mediaMinWidth('sm')} {
    order: -1;
    max-width: 70%;
  }

  ${mediaMinWidth('md')} {
    padding: ${theme.spacing['14x']} 0;
  }
`;

type Props = {
  title: string;
  description: string | null;
  benefits: string[] | null;
  cta: ReactNode;
  image: ReactNode;
  badge: ReactNode;
};

export const BasicPostPurchaseSuccessPromo = ({
  title,
  benefits,
  cta,
  image,
  badge,
  description,
}: Props) => {
  return (
    <>
      <ImageWrapper position="relative">
        {image}
        {badge}
      </ImageWrapper>
      <PromoText className={benefits && benefits.length > 0 ? 'has-benefits' : ''}>
        <Hidden below="tablet">
          <Text align="center" data-testid="checkout-success-promo-title" variant="heading5">
            {title}
          </Text>
        </Hidden>
        <Hidden above="mobile">
          <Text align="center" data-testid="post-purchase-success-promo-title" variant="heading6">
            {title}
          </Text>
        </Hidden>
        {benefits && benefits.length > 0 && <AnimatedBenefits benefits={benefits} />}
        {description !== null && <Text align="center">{description}</Text>}
        <Box display="flex" justifyContent="center">
          {cta}
        </Box>
      </PromoText>
    </>
  );
};
